/* eslint-disable */
import React from "react";
import { Select, TextField } from "mui-rff";
import { Form } from "react-final-form";
import { useTranslation } from "react-i18next";
import { LoadingButton } from "@mui/lab";
import { TStepFourForm } from "@/features/user/register/stepFour/types";
import MenuItemModalForm from "@/components/modal/MenuItemModalForm";
import NumberFormatCustom from "@/components/forms/NumberFormat";
import { InputAdornment } from "@mui/material";
import SimpleSpinner from "@/components/spinner/simpleSpinner";

const StepFourForm = (
    {
        onSubmit,
        initialValues,
        validateForm,
        required,
        submitting,
        selectDataIVA,
        selectDataIVAWithHolding,
        selectDataISRWithHolding,
        isModal,
        closePopover,
        setModalOpen,
        loading
    }: TStepFourForm): any => {

    const [t] = useTranslation();

    const formFields: any[] = [
        {
            field:
                <Select
                    label={t("step_four.label_iva")}
                    name="cat_vat_taxes_id"
                    required={required.cat_vat_taxes_id}
                    data={selectDataIVA}
                    multiple={false}
                    inputLabelProps={{ shrink: true }}
                    displayEmpty
                />
        },
        {
            field:
                <TextField
                    InputLabelProps={{ shrink: true }}
                    label={t("step_four.label_ieps_rate")}
                    name="ieps"
                    required={required.ieps}
                    InputProps={{
                        inputComponent: NumberFormatCustom,
                        endAdornment: (
                            <InputAdornment position="end">
                                %
                            </InputAdornment>
                        )
                    }}
                    inputProps={{
                        decimalScale: 2,
                        prefix: '',
                        fixedDecimalScale: true
                    }}
                />
        },
        {
            field:
                <Select
                    label={t("step_four.label_iva_withholding")}
                    name="cat_vat_rates_id"
                    required={required.cat_vat_rates_id}
                    data={selectDataIVAWithHolding}
                    multiple={false}
                    inputLabelProps={{ shrink: true }}
                    displayEmpty
                />
        },
        {
            field:
                <Select
                    label={t("step_four.label_isr_withholding")}
                    name="r_isr"
                    required={required.r_isr}
                    data={selectDataISRWithHolding}
                    multiple={false}
                    inputLabelProps={{ shrink: true }}
                    displayEmpty
                />
        },

    ]

    const modalProps: any = {
        hasMenuItem: true,
        label: t('step_four.title'),
        title: t('step_four.title'),
        formFields,
        onSubmit,
        initialValues,
        validateForm,
        required,
        submitting,
        closePopover,
        setModalOpen,
        loading
    }

    return (
        <>
            {
                !isModal &&
                <Form
                    onSubmit={onSubmit}
                    initialValues={initialValues}
                    validate={validateForm}
                    render={({ handleSubmit, errors }) => {
                        //console.log(errors)
                        return (
                            <>
                                {loading && <SimpleSpinner/>}
                                {!loading &&
                                    <form onSubmit={handleSubmit} noValidate>
                                        {formFields.map((item, idx) => (
                                            <div key={idx}>
                                                {item.field}
                                            </div>
                                        ))}

                                        <LoadingButton
                                            sx={{ mt: 3, mr: 1 }}
                                            //fullWidth
                                            size="large"
                                            type="submit"
                                            variant="contained"
                                            loading={submitting}
                                        >
                                            {t("common.save")}
                                        </LoadingButton>
                                    </form>
                                }
                            </>
                        )
                    }}
                />
            }

            {
                isModal &&
                <MenuItemModalForm
                    {...modalProps}
                />
            }
        </>
    );
}

export default StepFourForm;
